export default __webpack_public_path__ + "static/media/delete.287c2fb4.svg";